import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "destination",
  "use": "destination-usage",
  "viewBox": "0 0 12.34 16.517",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12.34 16.517\" id=\"destination\"><defs><style>#destination .a{fill:none;stroke:#1a1818;stroke-miterlimit:10;stroke-width:1.2px;}</style></defs><path class=\"a\" d=\"M11.573,5.219A5.569,5.569,0,1,0,1.2,8.776L4.95,15.171a1.3,1.3,0,0,0,2.237,0L10.9,8.83A5.553,5.553,0,0,0,11.573,5.219Zm-5.5,3.017A2.083,2.083,0,1,1,8.151,6.154,2.083,2.083,0,0,1,6.069,8.236Z\" transform=\"translate(0.1 0.105)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol